import { render } from "./CoursePermissions.vue?vue&type=template&id=be3c80cc&ts=true"
import script from "./CoursePermissions.vue?vue&type=script&lang=ts"
export * from "./CoursePermissions.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__